import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps } from '@mui/material';
import { faArrowDownToLine } from '@fortawesome/pro-solid-svg-icons';

type DownloadButtonProps = {
  onClick: ButtonProps['onClick'];
};

export const DownloadButton = (props: DownloadButtonProps) => {
  return (
    <Button
      onClick={props.onClick}
      startIcon={<FontAwesomeIcon icon={faArrowDownToLine} />}
    >
      Download
    </Button>
  );
};
